import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

export type MelloLogoMode = 'light' | 'dark';

@Component({
  selector: 'div[ui-mello-logo]',
  standalone: true,
  imports: [],
  templateUrl: './mello-logo.html',
  styleUrl: './mello-logo.css',
  host: {
    '[attr.data-mode]': 'mode',
    '[attr.data-show-background]': 'showBackground',
    '[attr.aria-label]': 'ariaLabel',
    '[attr.data-morphed]': 'isMorphed',
    '[attr.data-collapsed]': 'collapsed',
    '[attr.data-interactive]': 'interactive',
    '[attr.tabindex]': 'effectiveTabIndex',
    '[attr.role]': 'effectiveRole',
    '[attr.aria-pressed]': 'effectiveAriaPressed',
    '(keydown)': 'onKeydown($event)',
  },
})
export class MelloLogoComponent {
  @Input() mode: MelloLogoMode = 'light';
  @Input() showBackground = true;
  @Input() ariaLabel = 'Mello 2.0';
  @Input() morphed = false;
  @Input() collapsed = false;
  @Input() interactive = true;

  @Output() morphedChange = new EventEmitter<boolean>();

  get effectiveTabIndex(): string | null {
    return this.interactive ? '0' : null;
  }

  get effectiveRole(): string | null {
    return this.interactive ? 'button' : null;
  }

  get effectiveAriaPressed(): string | null {
    return this.interactive ? this.morphedAria : null;
  }
  readonly version = '2.0';
  readonly emptyAlt = '';
  readonly versionFontFamily = 'Geist Mono, ui-monospace, monospace';
  readonly versionFontSize = '16';
  readonly versionFontWeight = '800';
  readonly versionLetterSpacing = '-.2';
  readonly versionFill = 'currentColor';
  readonly cursorFill = '#afe321';

  get isMorphed(): boolean {
    return this.morphed || this.collapsed;
  }

  get morphedAria(): string {
    return this.isMorphed ? 'true' : 'false';
  }

  get symbolSrc(): string {
    return `/assets/mello-symbol-${this.mode}.svg`;
  }

  get wordmarkSrc(): string {
    return `/assets/mello-wordmark-${this.mode}.svg`;
  }

  @HostListener('click')
  toggle(): void {
    if (!this.interactive) return;
    this.morphed = !this.morphed;
    this.morphedChange.emit(this.morphed);
  }

  onKeydown(event: KeyboardEvent): void {
    if (!this.interactive) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggle();
    }
  }
}
